<template>
  <Popup v-model="show" round position="bottom"  get-container="body" close-on-popstate>
    <div class="edit-address">
      <span class="title">{{ addressData.seq ? '编辑收货地址' : '添加收货地址' }}</span>
      <div class="scroll-box">
        <span class="sub-title">收货人</span>
        <input type="text" class="input-box" :class="{ error: showError && !addressData.cname }"
          v-model="addressData.cname" placeholder="请输入" maxlength="12" />
        <span class="sub-title">手机号码</span>
        <input class="input-box" type="text" v-enter-tel :class="{ error: showError && !addressData.cmobile }"
          v-model="addressData.cmobile" placeholder="请输入" />
        <span class="sub-title">详细地址</span>
        <div class="textarea-box" :data-hint="`${addressData.daddr ? addressData.daddr.length : 0}/500`">
          <textarea class="textarea-box" :class="{ error: showError && !addressData.daddr }" maxlength="500"
            v-model="addressData.daddr" placeholder="请输入"></textarea>
        </div>
        <span class="default-opt" :class="{ 'default-opt-on': addressData.dflag == 1 }"
          @click="$set(addressData, 'dflag', addressData.dflag == 1 ? 0 : 1)">设为默认收货地址</span>
      </div>
      <div class="bottom-box">
        <van-button type="primary" class="button-fff" plain @click="show = false">取消</van-button>
        <van-button type="primary" @click="onConfirm()">确定</van-button>
      </div>
    </div>

  </Popup>
</template>

<script>
import { Popup } from 'vant';
export default {
  props: {
    value: [Boolean],
    data: {
      type: Object,
      default: () => {
        return {
          cname: '',
          cmobile: '',
          daddr: '',
          dflag: 1,
        }
      }
    }
  },
  data() {
    return {
      show: false,
      showError: true,
      addressData: {}
    }
  },
  watch: {
    value(val) {
      this.show = val;
      if (val) {
        this.showError = false;
        this.addressData = JSON.parse(JSON.stringify(this.data))
      }
    },
    show(val) {
      if (!val) {
        this.$emit('input', false);
      }
    }
  },
  created() {
  },
  components: {
    Popup
  },
  computed: {
  },
  methods: {
    onConfirm() {
      let errorArr = [];
      if (!this.addressData.cname) {
        errorArr.push('收货人');
      }
      if (!this.addressData.cmobile) {
        errorArr.push('手机号码');
      } else if (this.addressData.cmobile.length != 11) {
        errorArr.push('正确手机号码')
      }
      if (!this.addressData.daddr) {
        errorArr.push('详细地址');
      }
      if (errorArr.length > 0) {
        this.showError = true;
        this.$toastUtil.show('请输入' + errorArr.join('、'))
        return
      }

      let url = '/iap-api/wan4/addressbook/add.do'
      if (this.addressData.seq) {
        url = '/iap-api/wan4/addressbook/amend.do'
      }
      this.$ajax(url, this.addressData).then((res) => {
        this.show = false;
        if (!this.addressData.seq) {
          this.addressData.seq = res.data;
        }
        this.$emit('onFinish', this.addressData);
      })
    }
  }
}
</script>

<style scoped lang="less">
.edit-address {
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  padding-bottom: calc(env(safe-area-inset-bottom));

  >* {
    flex-shrink: 0;
  }

  .title {
    height: 108px;
    width: 100%;
    border-bottom: 1px solid #E5E6EB;
    color: #333;
    text-align: center;
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: 108px;
  }

  .scroll-box {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow-y: scroll;

    >* {
      flex-shrink: 0;
    }

    .sub-title {
      color: #333;
      font-size: 28px;
      font-style: normal;
      font-weight: 400;
      line-height: 38px;
      margin: 32px 32px 0;

      &::before {
        content: '*';
        color: #F53F3F;
        margin-right: 5px;
      }
    }

    .input-box {
      height: 88px;
      border-radius: 4px;
      border: 2px solid #DCDCDC;
      background: #F8F8F8;
      margin: 18px 32px 0;
      color: #333;
      font-size: 28px;
      font-style: normal;
      font-weight: 400;
      padding: 0 24px;
    }

    .textarea-box {
      margin: 18px 32px 0;
      position: relative;

      >textarea {
        height: 248px;
        min-height: 248px;
        max-width: 686px;
        min-width: 686px;
        border-radius: 4px;
        border: 2px solid #DCDCDC;
        background: #F8F8F8;
        padding: 10px 24px;
        color: #333;
        font-size: 28px;
        font-style: normal;
        font-weight: 400;
        line-height: 44px;
        margin: 0;
      }

      &::after {
        content: attr(data-hint);
        color: #999;
        font-size: 28px;
        font-style: normal;
        font-weight: 400;
        line-height: 44px;
        position: absolute;
        bottom: 10px;
        right: 24px;
      }
    }

    .default-opt {
      color: #999;
      font-size: 28px;
      font-style: normal;
      font-weight: 400;
      display: flex;
      align-items: center;
      margin: 24px 32px 32px;

      &::before {
        content: '';
        border: 2px solid #999;
        width: 34px;
        height: 34px;
        border-radius: 42px;
        margin-right: 12px;
      }

      &-on {
        color: #FF6634;

        &::before {
          content: '';
          border: none;
          width: 38px;
          height: 38px;
          background: url('https://xhdata.wan4.com/wsw-h5-21.png') no-repeat center;
          background-size: 100%;
          border-radius: 46px;
          margin-right: 12px;
        }
      }
    }
  }

  .bottom-box {
    height: 120px;
    display: flex;
    padding-right: 30px;
    background: #fff;
    align-items: center;

    .van-button {
      height: 88px;
      flex: 1;
      margin-left: 30px;
      font-size: 32px;
      border-radius: 8px;
    }

    .button-fff {
      background: #fff;
    }
  }

}

.error {
  border: 2px solid #F53F3F !important;
}
</style>
